import React, {PureComponent} from 'react';
import {Tab, Tabs} from 'react-bootstrap';
import {withRouter} from 'react-router-dom';

import {
    DWELL_TIME_URL,
    POST_RECEIVE_URL,
    POST_RECEIVE_WORK_VIEW_URL,
    PRE_RECEIVE_URL,
    PRE_RECEIVE_WORK_VIEW_URL,
    RouteUtilities as AppRouter
} from '../router/RouteDefinitions';
import AggregateViewReceive from '../aggregate/receive/AggregateViewReceive';
import MetricAggregateViewReceive from '../aggregate/receive/MetricAggregateViewReceive';
import {VIEW_NAMES_ENUM} from '../pojos/ViewNames';
import AggregateViewMainTable from '../aggregate/receive/AggregateViewMainTable';
import MetricAggregateViewMainTable from '../aggregate/receive/MetricAggregateViewMainTable';
import APIGatewayClientProvider, {APIGatewayClientContext} from '../provider/APIGatewayClientProvider';
import axios from 'axios';

const IS_WORK_VIEW_ENABLED_KEY = 'isWorkViewEnabled';

class ReceiveTabs extends PureComponent {

    static contextType = APIGatewayClientContext;

    constructor(props) {
        super(props);

        this.state = {
            isWorkViewEnabled: false
        };

        this.cancelTokenSource = APIGatewayClientProvider.createNewCancelTokenSource();
        this.updateActiveKey = this.updateActiveKey.bind(this);
    }

    componentDidMount() {
        this.fetchWorkViewFeatureFlag();
    }

    componentWillUnmount() {
        this.cancelTokenSource.cancel('Unmounting ReceiveTabs, cancelling work-view feature-flag fetch');
    }

    componentDidUpdate(prevProps) {
        const prevWarehouseId = prevProps.match.params.warehouseId;
        const currentWarehouseId = this.props.match.params.warehouseId;
        if (prevWarehouseId !== currentWarehouseId) {
            this.fetchWorkViewFeatureFlag();
        }
    }

    fetchWorkViewFeatureFlag() {
        const warehouseId = this.props.match.params.warehouseId;
        if (!warehouseId) {
            return;
        }
        // Cancel any in-flight request before starting a new one so an earlier warehouse's
        // response can't resolve after (and overwrite) a newer one, and so a pending request
        // is cancelled on unmount rather than calling setState on an unmounted component.
        this.cancelTokenSource.cancel('Superseded by a newer work-view feature-flag fetch');
        this.cancelTokenSource = APIGatewayClientProvider.createNewCancelTokenSource();
        this.context.client.getCustomConfigurationsByWarehouseId(warehouseId, this.cancelTokenSource.token)
            .then(response => {
                const configurations = response.data.warehouseCustomConfigurations;
                const isWorkViewEnabled = configurations && configurations[IS_WORK_VIEW_ENABLED_KEY] === 'true';
                this.setState({isWorkViewEnabled});
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.setState({isWorkViewEnabled: false});
                }
            });
    }

    render() {
        const activeKey = this.props.match.params.receive || null;
        const warehouseId = this.props.match.params.warehouseId;
        const {isWorkViewEnabled} = this.state;

        return (
            <Tabs className="justify-content-center receive-nav-tabs"
                  activeKey={activeKey}
                  mountOnEnter={true}
                  onSelect={this.updateActiveKey}>
                <Tab eventKey={PRE_RECEIVE_URL} title={VIEW_NAMES_ENUM.PRE_RECEIVE}>
                    <AggregateViewReceive viewName={VIEW_NAMES_ENUM.PRE_RECEIVE} warehouseId={warehouseId} mainTable={AggregateViewMainTable}/>
                </Tab>
                {isWorkViewEnabled &&
                    <Tab eventKey={PRE_RECEIVE_WORK_VIEW_URL} title={VIEW_NAMES_ENUM.PRE_RECEIVE_WORK_VIEW}>
                        <MetricAggregateViewReceive viewName={VIEW_NAMES_ENUM.PRE_RECEIVE_WORK_VIEW} warehouseId={warehouseId} mainTable={MetricAggregateViewMainTable}/>
                    </Tab>
                }
                <Tab eventKey={POST_RECEIVE_URL} title={VIEW_NAMES_ENUM.POST_RECEIVE}>
                    <AggregateViewReceive viewName={VIEW_NAMES_ENUM.POST_RECEIVE} warehouseId={warehouseId} mainTable={AggregateViewMainTable}/>
                </Tab>
                {isWorkViewEnabled &&
                    <Tab eventKey={POST_RECEIVE_WORK_VIEW_URL} title={VIEW_NAMES_ENUM.POST_RECEIVE_WORK_VIEW}>
                        <MetricAggregateViewReceive viewName={VIEW_NAMES_ENUM.POST_RECEIVE_WORK_VIEW} warehouseId={warehouseId} mainTable={MetricAggregateViewMainTable}/>
                    </Tab>
                }
                <Tab eventKey={DWELL_TIME_URL} title={VIEW_NAMES_ENUM.DWELL_TIME}>
                    <AggregateViewReceive viewName={VIEW_NAMES_ENUM.DWELL_TIME} warehouseId={warehouseId} mainTable={AggregateViewMainTable}/>
                </Tab>
            </Tabs>
        );
    }

    updateActiveKey(selectedKey) {
        const redirectURL = AppRouter.generateNewUrl(this.props.match.params.warehouseId, selectedKey);
        this.props.history.push(redirectURL);
    }
}

export default withRouter(ReceiveTabs);
